import { request } from "../utils/request";
import { AxiosPromise } from "axios";
import { ScenarioNodeType } from "types/scenario";

export type CreateScenarioPayload = {
  projectId: number;
  name: string;
};

export type UpdateScenarioPayload = {
  name: string;
  startNodeKey: string;
};

export type NodeOptionPayload = {
  label: string;
  nextNodeKey: string;
  position: number;
};

export type NodePayload = {
  key: string;
  type: ScenarioNodeType;
  content: string;
  variableKey: string;
  prevNodeKey: string;
  nextNodeKey: string;
  position: number;
  options: NodeOptionPayload[];
};

export const scenarioApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/scenarios",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/scenarios/${id}`,
    }),
  create: (data: CreateScenarioPayload): AxiosPromise<any> =>
    request({
      url: "/v1/admin/scenarios",
      data,
      method: "post",
    }),
  update: (id: number, data: UpdateScenarioPayload): AxiosPromise<any> =>
    request({
      url: `/v1/admin/scenarios/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/scenarios/${id}`,
      method: "delete",
    }),
  createNode: (scenarioId: number, data: NodePayload): AxiosPromise<any> =>
    request({
      url: `/v1/admin/scenarios/${scenarioId}/nodes`,
      data,
      method: "post",
    }),
  updateNode: (scenarioId: number, nodeId: number, data: NodePayload): AxiosPromise<any> =>
    request({
      url: `/v1/admin/scenarios/${scenarioId}/nodes/${nodeId}`,
      data,
      method: "patch",
    }),
  deleteNode: (scenarioId: number, nodeId: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/scenarios/${scenarioId}/nodes/${nodeId}`,
      method: "delete",
    }),
};
